// Lättviktig sidvisningsmätning: loggar besök per undersida till public.page_views.
// Fire-and-forget – ett fel i mätningen får aldrig störa sidan.

import { supabase } from '@/integrations/supabase/client';

const SESSION_KEY = 'lit_funnel_session_id';

function getSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

let lastPath: string | null = null;

export function logPageView(path?: string): void {
  try {
    if (typeof window === 'undefined') return;
    const pagePath = path ?? window.location.pathname;

    // Adminvyer och skanning är interna – mät inte dem
    if (pagePath.startsWith('/admin') || pagePath === '/scan') return;

    // Dubblettskydd: samma sökväg direkt igen loggas inte
    if (pagePath === lastPath) return;
    lastPath = pagePath;

    void (async () => {
      // Inloggade (admin/personal) ska inte förorena statistiken
      const { data } = await supabase.auth.getSession();
      if (data?.session) return;

      const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

      await supabase
        .from('page_views')
        .insert({
          page_path: pagePath.slice(0, 300),
          session_id: getSessionId(),
          is_mobile: /Mobi|Android|iPhone|iPad|iPod/i.test(ua),
          referrer: document.referrer ? document.referrer.slice(0, 300) : null,
          user_agent: ua ? ua.slice(0, 300) : null,
        })
        .then(() => undefined, () => undefined);
    })().catch(() => undefined);
  } catch {
    // ignorera
  }
}
